export default __webpack_public_path__ + "images/oHRLogo.47821745031b99a68f1886c9e61211e9.svg";